import { Button, Form, InputGroup } from 'react-bootstrap';

interface Props {
  setValue: (value: string) => void;
  onSave: () => void;
  value: string;
  placeholder: string;
  errors: string[];
  isDisabled?: boolean;
}
const AddNewItem = ({ value, setValue, onSave, placeholder, errors, isDisabled }: Props) => {
  return (
    <InputGroup
      size="sm"
      hasValidation
    >
      <Form.Control
        value={value}
        onChange={(e: { target: { value: string } }) => setValue(e.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSave();
          }
        }}
        type="text"
        isInvalid={errors.length != 0}
        id={`${placeholder.replaceAll(' ', '-').toLowerCase()}-input`}
        data-testid="add-new-item-input"
        placeholder={placeholder}
        disabled={isDisabled}
        className="rounded-pill border-2"
      />

      <Button
        onClick={onSave}
        id={`${placeholder.replaceAll(' ', '-').toLowerCase()}-save-button`}
        data-testid="add-new-item-save"
        disabled={isDisabled || value.trim() === ''}
        className="btn-danger px-3 ms-2 rounded-pill fw-bold"
      >
        Add
      </Button>
      <Form.Control.Feedback type="invalid">
        {errors.map((error, index) => (
          <div
            data-testid="add-new-item-error"
            key={index}
          >
            {error}
          </div>
        ))}
      </Form.Control.Feedback>
    </InputGroup>
  );
};

export default AddNewItem;
